import { Fragment } from 'react';

import { TFundingRequirement } from '@helpers/FundingRequirements/fundingRequirements.types';
import { Divider, Stack } from '@iwoca/orion';

import { ApplicantCallRow } from './requirements/ApplicantCall/ApplicantCallRow';
import { BankDetailsRow } from './requirements/BankDetails/BankDetailsRow';
import { CreditAgreementRow } from './requirements/CreditAgreement/CreditAgreementRow';
import { IdVerificationRow } from './requirements/IdVerification/IdVerificationRow';
import { PersonalGuaranteeRow } from './requirements/PersonalGuarantee/PersonalGuaranteeRow';
import { UploadBankEvidenceRow } from './requirements/UploadBankEvidence/UploadBankEvidenceRow';
import { UploadGewerbescheinRow } from './requirements/UploadGewerbeschein/UploadGewerbescheinRow';
import { useGetFundingRequirements } from '../../hooks/useGetFundingRequirements';

export const RequirementsList = () => {
    const { requirements } = useGetFundingRequirements();

    return (
        <Stack gap="none" data-testid="requirements-list">
            {requirements.map((requirement, index) => (
                <Fragment key={requirement.type}>
                    {index > 0 && <Divider />}
                    <RequirementRow {...requirement} />
                </Fragment>
            ))}
        </Stack>
    );
};

const RequirementRow = (requirement: TFundingRequirement) => {
    switch (requirement.type) {
        case 'bank_details':
            return <BankDetailsRow {...requirement} />;
        case 'id_verification':
            return <IdVerificationRow {...requirement} />;
        case 'upload_gewerbeschein':
            return <UploadGewerbescheinRow {...requirement} />;
        case 'credit_agreement':
            return <CreditAgreementRow {...requirement} />;
        case 'personal_guarantee':
            return <PersonalGuaranteeRow {...requirement} />;
        case 'upload_bank_evidence':
            return <UploadBankEvidenceRow {...requirement} />;
        case 'applicant_call':
            return <ApplicantCallRow {...requirement} />;
    }
};
